import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import UserAuthContainer from '../Containers/UserAuthContainer'
import ROUTES from '../../routesConfig'

const PUBLIC_PATHS_WITHOUT_AUTH_REDIRECT = new Set([
  ROUTES.ROOT,
  ROUTES.HOME,
  ROUTES.APPS,
  ROUTES.ABOUT,
  ROUTES.PRIVACY,
  ROUTES.TERMS,
  ROUTES.HOW_IT_WORKS,
  ROUTES.WEDDINGS,
  ROUTES.VENUES,
  ROUTES.MEETUPS,
  ROUTES.LOGIN,
  ROUTES.LOGOUT,
  ROUTES.SIGNUP,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.VERIFY_EMAIL,
  ROUTES.GUEST_SIGNUP,
])

const GuestReestablishGate = () => {
  const { guestReestablishMeta } = UserAuthContainer.useContainer()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!guestReestablishMeta) return
    if (location.pathname === ROUTES.GUEST_EXPIRED) return
    if (!PUBLIC_PATHS_WITHOUT_AUTH_REDIRECT.has(location.pathname)) return

    navigate(ROUTES.GUEST_EXPIRED, {
      replace: true,
      state: { reestablishMeta: guestReestablishMeta },
    })
  }, [guestReestablishMeta, location.pathname, navigate])

  return null
}

export default GuestReestablishGate
